import type {AuditParamDefinitions} from './AuditParamDefinitions';

export type AuditParamValue = {
  value: string;
  label: Record<string, string> | null;
  openCategoryWithKey: string | null;
  content: AuditParamDefinitions | null;
  featureKey: string | null;
  id?: string | null;
};
